import { type MarginReportChartInput } from '@enechain/eposition-ui'

import { type MarginReportEntryModel } from '~/pages/MarginReport/models/marginReportEntry'

export function convertEntriesToChartData(entries: MarginReportEntryModel[]): {
  data: MarginReportChartInput[]
  marginCallDates: Set<string>
} {
  const data = entries.map((entry) => ({
    date: entry.date,
    deposits: entry.deposits,
    performanceGuarantee: entry.performanceGuarantee,
    totalCreditAmount: entry.totalCreditAmount,
    unrealizedAmount: entry.unrealizedAmount,
    realizedAmount: entry.realizedAmount,
    materializedUnsettledAmount: entry.materializedUnsettledAmount,
    requiredMargin: entry.requiredMargin,
    initialMargin: entry.initialMargin,
    surplus: entry.surplus,
    guaranteeIssuanceLimit: entry.guaranteeIssuanceLimit,
  }))

  const marginCallDates = new Set(
    entries.filter((e) => e.isMarginCallDay).map((e) => e.date),
  )

  return { data, marginCallDates }
}
